import { AppState } from '../../init/rootReducer';
import { GeneralState } from './types';

export const getGeneralState = (state: AppState): GeneralState => state.general;
export const getGeneralSideMenuCollapsed = (state: AppState): boolean =>
  state.general.sideMenuCollapsed;
